import React from 'react';
import { Modal, Collapse, Button, Row, Col, Card, Typography, Spin, Divider, Input, Image, Space, Table } from 'antd';
import evmLib from '../evmLib';
import Lib from '../Lib';
import moment from 'moment';
import TXAlert from './TXAlert';

const { Panel } = Collapse;
const { Title } = Typography;
const {
  VAULT_LINK,
  VAULTREWARD_LINK,
  TRADE_LINK
} = require('../config');


class PoSVault extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stakeAmount: ''
    };
  }

  async componentDidMount() {
    const blockchainTime = await evmLib.getBlockchainTime();
    this.setState({ blockchainTime });

    await this.refreshVaultData();
  }

  async getSnapshotBeforeUpdate(prevProps, prevState) {
    const prevMetamask = prevProps.metamask;
    const nextMetamask = this.props.metamask;

    if (!prevMetamask && nextMetamask) {
      await this.refreshVaultDataUser();
    }
  }

  componentDidUpdate() {
    return true;
  }

  modalError(msg) {
    Modal.error({
      title: 'Vault Error',
      centered: true,
      maskClosable: true,
      content: msg,
      okType: 'outline'
    });
  }

  async refreshVaultData() {
    this.setState({ vaultData: null });
    const vaultData = await evmLib.getPosVaultData();
    this.setState({ vaultData });
  }

  async refreshVaultDataUser() {
    this.setState({ vaultDataUser: null });
    const wallet = this.props.metamask.getSigner();
    wallet.address = await wallet.getAddress();
    const vaultDataUser = await evmLib.getPosVaultDataUser(wallet);
    this.setState({ vaultDataUser });
  }

  componentWillUnmount() {
  }

  async claimVaultYield() {
    try {
      const signer = this.props.metamask.getSigner();
      this.setState({ showTxPopup: true, txHash: false, txStatus: 'waiting' });
      let tx = await evmLib.claimPosVaultYield(signer);
      this.setState({ txHash: tx.hash });
      await tx.wait();
      this.setState({ txStatus: 'confirmed' });
      await this.refreshVaultDataUser();
    } catch (err) {
      console.error(err);
      this.setState({ txStatus: 'fail' });
    }
  }

  async approveVault() {
    try {
      const signer = this.props.metamask.getSigner();
      this.setState({ showTxPopup: true, txHash: false, txStatus: 'waiting' });
      let tx = await evmLib.approveLPVault(signer);
      this.setState({ txHash: tx.hash });
      await tx.wait();
      this.setState({ txStatus: 'confirmed' });
      await this.refreshVaultDataUser();
    } catch (err) {
      console.error(err);
      this.setState({ txStatus: 'fail' });
    }
  }

  async stakeVault() {
    const wallet = this.props.metamask.getSigner();
    wallet.address = await wallet.getAddress();

    // 'Before stake/unstake, please claim unclaimed yield.'
    // 'Amount is not multiples of 1000 CFX'
    // 'Wallet dont have enough CFX. Buy CFX at SWAPPI.'
    const amount = this.state.stakeAmount;
    if (!amount || amount === '')
      return this.modalError('Please enter amount to stake/unstake.');

    const amountWei = evmLib.eth2wei(amount);
    const balance = await evmLib.getWalletBalance(wallet.address);

    if (Number(amount) < 1000)
      return this.modalError('Currently PHXPool require minimum stake of 1000 CFX.');
    if (this.state.vaultDataUser && Number(this.state.vaultDataUser.unclaimedReward) > 0)
      return this.modalError('Before stake/unstake, please claim unclaimed yield');
    if (balance.lt(amountWei))
      return this.modalError('Wallet dont have enough CFX. Buy CFX at SWAPPI.');
    if (Number(amount) - (Math.floor(Number(amount) / 1000) * 1000) > 0)
      return this.modalError('Amount is not multiples of 1000 CFX.');

    try {
      this.setState({ showTxPopup: true, txHash: false, txStatus: 'waiting' });
      let tx = await evmLib.stakePosVault(wallet, amount);
      this.setState({ txHash: tx.hash });
      await tx.wait();
      this.setState({ txStatus: 'confirmed' });
      await this.refreshVaultDataUser();
    } catch (err) {
      console.error(err);
      this.setState({ txStatus: 'fail' });
    }

  }

  async unstakeVault() {
    const wallet = this.props.metamask.getSigner();
    wallet.address = await wallet.getAddress();

    // 'Before stake/unstake, please claim unclaimed yield.'
    // 'Amount is not multiples of 1000 CFX'
    // 'Not enough CFX to unstake. Stake CFX first.' 
    const amount = this.state.stakeAmount;
    if (!amount || amount === '')
      return this.modalError('Please enter amount to stake/unstake.');

    if (this.state.vaultDataUser && Number(this.state.vaultDataUser.unclaimedReward) > 0)
      return this.modalError('Before stake/unstake, please claim unclaimed yield');
    if (Number(amount) - (Math.floor(Number(amount) / 1000) * 1000) > 0)
      return this.modalError('Amount is not multiples of 1000 CFX.');
    if (this.state.vaultDataUser && Number(amount) > Number(this.state.vaultDataUser.numStake))
      return this.modalError('Not enough CFX to unstake. Stake CFX first.');


    try {
      this.setState({ showTxPopup: true, txHash: false, txStatus: 'waiting' });
      let tx = await evmLib.unstakePosVault(wallet, amount);
      this.setState({ txHash: tx.hash });
      await tx.wait();
      this.setState({ txStatus: 'confirmed' });
      await this.refreshVaultDataUser();
    } catch (err) {
      console.error(err);
      this.setState({ txStatus: 'fail' });
    }
  }

  async claimWithdrawRequest(index) {
    try {
      this.setState({ showTxPopup: true, txHash: false, txStatus: 'waiting' });
      let tx = await evmLib.claimPosVaultWithdraw(this.props.metamask.getSigner(), index);
      this.setState({ txHash: tx.hash });
      await tx.wait();
      this.setState({ txStatus: 'confirmed' });
      await this.refreshVaultDataUser();
    } catch (err) {
      console.error(err);
      this.setState({ txStatus: 'fail' });
    }
  }

  renderAPYCalc() {
    const d = this.state.vaultData;
    const priceToken = Lib.to5digit(d.priceToken);
    const dailyInterest = Lib.to5digit(d.dailyInterest);
    const dailyInterest1000Cfx = Lib.to5digit(d.dailyInterest1000Cfx);
    const dailyInterest1Cfx = Lib.to5digit(d.dailyInterest1Cfx);
    const apyCalc1 = Lib.to5digit(d.apyCalc1);
    const apyCalc2 = Lib.to5digit(d.apyCalc2);

    return (
      <div style={{ textAlign: 'center' }}>
        <div>Price in CFX:</div>
        <div>1 TXT = {priceToken} CFX</div>
        <div>Avg. Daily Yield/Stake: {dailyInterest} TXT/Stake</div>
        <div>{dailyInterest1000Cfx} CFX/Stake = {dailyInterest1000Cfx} CFX/1000 CFX = {dailyInterest1Cfx}</div>
        <div>APY Calculation:</div>
        <div>(1 + {dailyInterest1Cfx})^365 - 1 * 100%</div>
        <div>{apyCalc1} - 1  * 100%</div>
        <div>{apyCalc2} * 100%</div>
      </div>
    );
  }

  renderPendingUnstake() {
    const now = this.state.blockchainTime ? moment.unix(this.state.blockchainTime) : moment();
    const du = this.state.vaultDataUser;
    const dataSource = du.pendingWithdraw;
    const columns = [
      {
        title: (<div style={{ textAlign: 'center' }}>DATA</div>),
        dataIndex: 'data',
        render: (text, record) => {
          // wrIndex,
          // withdrawAmount
          // deadline
          const wrIndex = record.wrIndex;
          const withdrawAmount = record.withdrawAmount;
          const deadline = moment.unix(record.deadline).format('DD/MM/YY HH:mm:ss');
          let enable = now.isAfter(moment.unix(record.deadline));

          return (
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              <Space direction='vertical' align='center'>
                <div style={{ textAlign: 'center' }}>{withdrawAmount} CFX</div>
                <div style={{ textAlign: 'center' }}>Can be Claimed After:</div>
                <div style={{ textAlign: 'center' }}>{deadline}</div>
                <Button disabled={!enable} type='primary' onClick={() => this.claimWithdrawRequest(wrIndex)}>CLAIM</Button>
              </Space>
            </div>
          );
        },
        responsive: ['xs']
      },
      {
        title: 'Amount CFX',
        dataIndex: 'withdrawAmount',
        key: 'withdrawAmount',
        responsive: ['sm']
      },
      {
        title: 'Can be Claimed After',
        dataIndex: 'deadline',
        key: 'deadline',
        responsive: ['sm'],
        render: (text, record) => {
          const deadline = moment.unix(record.deadline).format('DD/MM/YY HH:mm:ss');
          return (
            deadline
          )
        },
      },
      {
        title: 'Action',
        render: (text, record) => {
          const deadline = record.deadline;
          const wrIndex = record.wrIndex;
          const enable = now.isAfter(moment.unix(deadline));
          return (
            <Space size="middle">
              <Button disabled={!enable} type='primary' onClick={() => this.claimWithdrawRequest(wrIndex)}>CLAIM</Button>
            </Space>
          )
        },
        responsive: ['sm']
      },
    ];

    return (
      <Col xs={24} sm={24}>
        <Divider />
        <div style={{ textAlign: 'center' }}>
          <div>Pending Unstake</div>
          <div>&nbsp;</div>
        </div>
        <Table bordered dataSource={dataSource} columns={columns} />
      </Col>
    );
  }

  render() {
    const title = 'PoS VAULT';
    const tokenName = 'CFX';
    const yieldName = 'TXT';
    const infoMsg1 = 'PoS VAULT is yield optimizer for Conflux PoS Pool. The vault currently optimize yield on PHXVerse Pool. At this time required minimal staking is 1000 CFX. Important: PHX Pospool smartcontract (verified in confluxscan) still use locking/unlocking periods of 7 days, but conflux hardfork already change staking parameter to 13/1 for locking/unlocking period. To make PoS VAULT optimizer work without problem, unstake button will be enable after 14 days and pending withdraw can be claimed after 8 days.';
    const infoMsg2 = 'Trade CFX or TXT in SWAPPI';
    const unstakeEnableTime = '14 days';
    const imgUrl = 'https://res.cloudinary.com/dey55ubjm/image/upload/v1660552313/tbotx/CFX.png';

    let apyInfo = <Spin />;
    let numStaked = '-';
    let unstakeAllowDate = '-';
    let nextRewardAvailable = '-';
    let unclaimedYield = '-';
    let noUserData = true;
    let enableUnstake = false;
    let numOwned = '-';
    let approved = true;
    let apyCalc = null;
    let dataSource = [];
    let enableMax = false;

    const now = this.state.blockchainTime ? moment.unix(this.state.blockchainTime) : moment();
    let info = (
      <Col xs={24}>
        <Collapse accordion>
          <Panel header="Vault Information">
            <Row gutter={[8, 8]}>
              <Col xs={24}>
                <p>{infoMsg1}</p>
                <p>{infoMsg2}</p>
              </Col>
              <Col xs={24}>
                <Button type='outline' block onClick={() => Lib.openUrl('https://pospool.phxverse.com')}>VISIT PHXVERSE POOL</Button>
              </Col>
              <Col xs={24}>
                <Button type='outline' block onClick={() => Lib.openUrl(VAULT_LINK)}>VERIFY POSVAULT CONTRACT</Button>
              </Col>
              <Col xs={24}>
                <Button type='outline' block onClick={() => Lib.openUrl(VAULTREWARD_LINK)}>VERIFY POSREWARD CONTRACT</Button>
              </Col>
              <Col xs={24}>
                <Button type='outline' block onClick={() => Lib.openUrl(TRADE_LINK)}>TRADE CFX OR TXT</Button>
              </Col>
            </Row>

          </Panel>
          
        </Collapse>
      </Col>
    );

    if (this.state.vaultData) {
      const d = this.state.vaultData;
      apyInfo = <Title level={4}>APY {Lib.to2digit(d.apy)}%</Title>;
      nextRewardAvailable = moment.unix(d.nextRewardAvailable).format('DD/MM/YY HH:mm:ss');
      apyCalc = this.renderAPYCalc();

      if (this.state.vaultDataUser) {
        noUserData = false;
        const du = this.state.vaultDataUser;
        numOwned = du.ownedCFX;
        numStaked = du.numStake;
        unstakeAllowDate = moment.unix(du.unstakeTime).format('DD/MM/YY HH:mm:ss');
        unclaimedYield = Lib.to5digit(du.unclaimedReward);
        enableUnstake = now.isAfter(moment.unix(du.unstakeTime)) && Number(numStaked) > 0;
        dataSource = du.pendingWithdraw;
        enableMax = (Number(numOwned) > 0)
      }
    }

    let pendingUnstake;
    if (dataSource && dataSource.length > 0) {
      pendingUnstake = this.renderPendingUnstake();
    }

    let disableBtnYieldClaim = true;
    let txtYield = <div>&nbsp;</div>;

    if (Number(numStaked) > 0 && Number(unclaimedYield) > 0) {
      disableBtnYieldClaim = false;
      txtYield = (
        <div style={{ textAlign: 'center' }}>
          Unclaimed Yield: {unclaimedYield} {yieldName}
        </div>
      );
    } else if (nextRewardAvailable !== '-') {
      txtYield = (
        <div style={{ textAlign: 'center' }}>
          Yield Available: {nextRewardAvailable}
        </div>
      );
    }

    if (Number(numStaked) > 0 && Number(unclaimedYield) > 0) {
      disableBtnYieldClaim = false;
    }

    let txtUnstakeTime = (
      <div style={{ textAlign: 'center' }}>
        <div>Unstake will be enable {unstakeEnableTime} after last Stake</div>
      </div>
    );

    if (Number(numStaked) > 0 && !enableUnstake) {
      txtUnstakeTime = (
        <div style={{ textAlign: 'center' }}>
          <div>Unstake allowed after {unstakeAllowDate}</div>
        </div>
      );
    }

    let btnStake;
    let btnUnstake;
    if (approved) {
      btnStake = (
        <Col xs={12}>
          <Button disabled={noUserData} type='primary' block onClick={() => this.stakeVault()}>STAKE</Button>
        </Col>
      );
      btnUnstake = (
        <Col xs={12}>
          <Button disabled={noUserData || !enableUnstake} type='primary' block onClick={() => this.unstakeVault()}>UNSTAKE</Button>
        </Col>
      );
    }

    let calcInfo = (
      <Col xs={24} sm={24}>
        <div style={{ textAlign: 'center' }}>
          {apyCalc}
          <div>&nbsp;</div>
          {apyInfo}
          <div><Button type="link" onClick={() => this.setState({ showAPYCalc: false })}>HIDE APY CALCULATION</Button></div>
        </div>
      </Col>
    );

    if (!this.state.showAPYCalc) {
      calcInfo = (
        <Col xs={24} sm={24}>
          <div style={{ textAlign: 'center' }}>
            <Image
              height='64px'
              src={imgUrl}
            />
            <div>&nbsp;</div>
            <div>Stake {tokenName} Earn {yieldName}</div>
            {apyInfo}
            <div><Button type="link" onClick={() => this.setState({ showAPYCalc: true })}>SHOW APY CALCULATION</Button></div>
          </div>
        </Col>
      );
    }

    return (
      <Card title={
        <Title level={4}>{title}</Title>
      } style={{ height: '100%' }} headStyle={{ textAlign: 'center' }}>
        <TXAlert showTxPopup={this.state.showTxPopup} txStatus={this.state.txStatus} txHash={this.state.txHash}
          onBack={() => this.setState({ showTxPopup: false })} />
        <Row gutter={[8, 8]}>
          {info}
          <div>&nbsp;</div>
        </Row>
        <Row gutter={[8, 8]}>
          {calcInfo}
        </Row>
        <Divider />
        <Row gutter={[8, 8]}>
          <Col xs={24} sm={24}>
            <div style={{ textAlign: 'center' }}>
              <div>Staked: {numStaked} {tokenName}</div>
              {txtUnstakeTime}
              Owned: {numOwned} {tokenName}
            </div>
          </Col>
          <Col xs={24}>
            <div style={{ display: 'flex' }}>
              <div style={{ flex: 1 }}>
                <Input disabled={!approved} addonAfter={tokenName} placeholder='Enter amount to stake/unstake'
                  value={this.state.stakeAmount}
                  onChange={(e) => this.setState({ stakeAmount: e.target.value })}
                />
              </div>
              <div>
                <Button disabled={!enableMax} type="link" onClick={() => this.setState({ stakeAmount: ('' + numOwned) })}>MAX</Button>
              </div>
            </div>
          </Col>
          {btnStake}
          {btnUnstake}
          <Col xs={24}>
            <Divider />
            {txtYield}
          </Col>
          <Col xs={24}>
            <Button disabled={noUserData || disableBtnYieldClaim} type='primary' block onClick={() => this.claimVaultYield()}>CLAIM</Button>
          </Col>
          {pendingUnstake}
        </Row>
      </Card >
    );
  }

}

export default PoSVault;
